import * as Yup from 'yup'
import { Form } from 'react-bootstrap'

export const Schema = Yup.object().shape({
    
});

export const PrivacyConsentSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { dataSecurityUrl } = props;
    return (
        <>
            <Form.Group controlId="privacyConsent">
                <Form.Check
                    required
                    name="terms"
                    type="checkbox"
                    onChange={handleChange}
                    isInvalid={touched.terms && !!errors.terms}
                    feedback={errors.terms}
                    feedbackType="invalid"
                    label={<span>* Ich habe die <a href={dataSecurityUrl} target="_blank" rel="noreferrer" >Datenschutzbestimmungen</a> zur Kenntnis genommen und stimme der Datenverarbeitung zu.</span>}>
                </Form.Check>
            </Form.Group>
        </>
    );
};